type ClinicalSpeciality = {
  necessityLevel: string;
  clinicalSpecialty: {
    id: string;
    displayName: string;
    __typename?: string;
  };
};

export const formatSelectedSpecialties = (
  staffingRequestSpecialties: ClinicalSpeciality[]
) =>
  staffingRequestSpecialties?.map((specialty) => ({
    id: specialty.clinicalSpecialty.id,
    displayName: specialty.clinicalSpecialty.displayName,
    __typename: specialty.clinicalSpecialty.__typename,
    required: specialty.necessityLevel === 'required',
  }));

type Certification = {
  necessityLevel: string;
  certification: {
    id: string;
    name: string;
    credential?: string;
    __typename?: string;
  };
};

export const formatSelectedCertifications = (
  staffingRequestCertifications: Certification[]
) =>
  staffingRequestCertifications?.map((certification) => ({
    id: certification.certification.id,
    name: certification.certification.name,
    __typename: certification.certification.__typename,
    credential: certification.certification?.credential,
    required: certification.necessityLevel === 'required',
  }));
